<template>
    <reo-dialog
        @cancel="handleCancel"
        class="deviceShow"
        :title="$t('subscribe.showModels')"
        :showButton=false
        :isBottomWhenMobile="true">
        <template v-slot:model-show-des>
            <div>
                <p class="des">{{ $t('subscribe.device_note') }}</p>
            </div>
        </template>
        <template v-slot:deviceSearch>
            <div class='deviceSearch'>
                <model-show
                    :list="supportedDeviceList"
                    :category="cloudProductLists.deviceCategory"
                    :noMatch="$tc('modelShow.no_match')">
                </model-show>
            </div>
        </template>
    </reo-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import ReoDialog from '@/basic/Dialog.vue';

export default Vue.extend({
    name: 'AvailableCountriesDialog',
    components: {
        ReoDialog
    },
    props: {
        supportedDeviceList: Array,
        cloudProductLists: Object,
        deviceGroupDes: String
    },
    methods: {
        handleConfirm() {

            this.$emit( 'confirm' );

        },

        handleCancel() {

            this.$emit( 'cancel' );

        }
    }

});
</script>

<style lang="less" scoped>

    .dialog.reo-dialog.deviceShow.bottom /deep/ .reo-dialog-inner{
        min-height: 100% !important;
        display: flex;
        flex-direction: column;
        @media @pc{
            --dialog-padding-top: 48px;
            --dialog-padding-right: 48px;
            width: 100%;
            max-width: 1000px !important;
            min-height: 700px !important;
            max-height: 700px !important;
            padding: 48px;
        }
        @media @mobile{
            --dialog-padding-top: 24px;
            --dialog-padding-right: 20px;
            padding: 24px 20px;
            min-height: calc(100% - 1rem) !important;
            max-height: calc(100% - 1rem) !important;
        }
        .close-icon{
            @media @pc{
                width: 24px;
                height: 24px;
            }
            @media @mobile{
                width: 20px;
                height: 20px;
            }
        }
        p.dialog-title{
            font-weight: 600;
            line-height: 1.3;
            text-align: left;
            color: @font_primary;
            @media @pc{
                font-size: 28px;
                margin-bottom: 8px;
                padding: 0;
            }
            @media @mobile{
                font-size: 22px;
                margin-bottom: 6px;
                padding: 0;
            }
        }
        .des{
            font-size: 14px;
            line-height: 1.4;
            text-align: left;
            color: @font_primary;
        }
        .scroll-context{
            overflow: visible;
        }
    }

    .deviceSearch{
        flex: 1;
        min-height: 0;
        overflow: hidden;
        display: flex;
        flex-direction: row;
        justify-content: center;
        @media @pc{
            margin: 0 -48px;
        }
        @media @mobile{
            margin: 0 -20px;
        }
        /deep/ .search-container,
        /deep/ .model-show-list{
            box-sizing: border-box;
            @media @pc{
                padding-left: 48px;
                padding-right: 48px;
            }
            @media @mobile{
                padding-left: 20px;
                padding-right: 20px;
            }
        }
        /deep/ .model-show-list{
            margin-right: 4px;
            scrollbar-color: @font_tertiary transparent;

            @media @pc{
                padding-right: 44px;
            }
            @media @mobile{
                padding-right: 16px;
            }

            &::-webkit-scrollbar-thumb{
                background-color: @font_tertiary;
            }
        }
        /deep/ ul{
            overflow-y :auto;
            overflow-y: overlay;
        }
    }
</style>
